// extracted by mini-css-extract-plugin
module.exports = {"partner-tile":"PartnerTile_partner-tile__PK6U3","logo":"PartnerTile_logo__ezywu"};